/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-34428f12.mjs';

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray;

export { _setToArray as _ };
//# sourceMappingURL=dep-934f61a2.mjs.map
